const queueTreatmentConfig: any = {
  queueTreatmentList: [],
  queueTreatmentLoaded: false,
  loadingQueueTreatments: false,
  deletingQueueTreatment: false,
  workingQueueTreatment: null,
  queues: [],
  queuesLoaded: false,
  flows: [],
  flowsLoaded: false,
  customerQueueFlows: [],
  availableHours: [],
  availableHoursLoaded: false,
  menuList: [],
  menusLoaded: false,
  numbers: [],
  availableNumbers: [],
  numbersLoaded: false,
  availableCustomHours: [],
  prompts: [],
  promptsLoaded: false,
  message: '',
  loadingQueueFlowMapper: true,
  queueFlowMapperLoaded: false,
  queueFlowMapper: null,
};

export default queueTreatmentConfig;
